import { render, staticRenderFns } from "./CoverageAreas.vue?vue&type=template&id=01ad8739"
import script from "./CoverageAreas.vue?vue&type=script&lang=js"
export * from "./CoverageAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports